module.exports = __webpack_public_path__ + "token_spending_marketplace.8fa683f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/token_spending_marketplace.png
// module id = 474
// module chunks = 0